$.fn.ContractTable = function(_ctr)
{
	var _ct = this;
	_ct.ctr = _ctr;

	_ct.load = function(elements_list)
	{
		// empty
		_ct.reset();

		// load each element list
		elements_list.forEach(function(element, index){
			var contract_row = $('#template-import-contract-row').clone().ContractRow(_ct);
			contract_row.load(element);
			_ct.find("tbody").append(contract_row);
		});

		// make visible
		if (elements_list.length){
			_ct.show();
		}
	};

	_ct.reset = function()
	{
		_ct.find("tbody tr").remove();
		_ct.hide();
	};

	return function()
	{
		_ct.reset();
		return _ct;
	}();
}

$.fn.ContractRow = function(_ctr)
{
	var _cr = this;
	_cr.ctr = _ctr;
	_cr.interface = {
		import_button : _cr.find("button[data-action='import-options-list']")
	};

	_cr.load = function(element)
	{
		_cr.interface.import_button.data("config_name", element.config);
		_cr.interface.import_button.data("options_list", element.options_list);
		_cr.find(".cell-invoice-id").text(element.invoice.str_id);
		_cr.find(".cell-invoice-date").text(element.display_date);
		_cr.find(".cell-invoice-reference").text(element.invoice.reference);
		var fee = asFloat(element.fee);
		_cr.find(".cell-invoice-fee").text(fee.toLocaleString('fr-CA', {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		}));
		if (element.config == 'inm_2016') {
			_cr.find(".cell-invoice-cycle").text('');
		} else {
			_cr.find(".cell-invoice-cycle").text(element.cycle);
		}
		_cr.find(".cell-invoice-cycle_dates").text(element.display_cycle_dates);
		_cr.find(".cell-config-display").text(element.display_config);
		_cr.find(".preview-link").attr("href", "/facture/previsualiser/" + element.invoice.id);
	};

	_cr.import = function()
	{
		// import
		_cr.ctr.ctr.e.interface.tabs.fee.import($(this).data("config_name"), $(this).data("options_list"));

		// next tab
		_cr.ctr.ctr.e.reachTab(1);

		// success notification
		$.slr.notify({
			icon: 'fa fa-check',
			title: "Liste d'options importées",
			message: "La liste d'options a été importée depuis un autre élément du même contrat."
		}, { type: 'success' });
	};

	return function()
	{
		_cr.interface.import_button.on("click", _cr.import);
		return _cr;
	}();
};
